module.exports = __webpack_public_path__ + "static/image2-b111f7773fb7b07a97b3d2640b96e952.jpg";